

import $ from 'jquery'
import { closeModal } from '@/functions/function.js';

export default {
    name: 'TypeArticles',
    components: {},
    props: [],
    data () {
      return {
          fields: ['libelle', 'articles', 'actions'],
          filter: "",
          perPage: 8,
          currentPage: 1,
          type: {},
          libelle: null,
          loading: false,
          check: true,          
      }
    },
    computed: {
      types() {
          return this.$store.getters['types']
      },
  
    },
    mounted () {
        setTimeout(() => {
            $('.p-content').fadeIn();
        }, 500);

      this.$store.dispatch("getTypes");
    },
    methods: {
        setType(data) {
            this.type=data
            this.libelle=data.libelle
        },

        async submitForm() {
            this.loading=true

            if(this.type.libelle != this.libelle) {
                this.check = true
                const data = {
                    libelle:  this.libelle,
                }   
                await this.$store.dispatch("editTypeArticle",{ 
                    id:this.type.id , 
                    data: data 
                }).then(
                    response => {
                        console.log(response)

                        if (response) {
                            this.$refs.close_modal.click()
                            this.loading=false
                        } 
                    }
                );
            } else {
                //Si valeur identique afficher un message d'erreur
                this.check = false
            }
        },

        /**
         * Close Modal
         * @param {*} selector 
        */
        closeModal(selector) 
        {
            closeModal.closeModal(selector);
        }
    }
}
  
  
  

